import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {OrganizeDropEvent, toOrganizeDropEvent, WorkspaceMemberRow} from '../organize-teams.models';

const LOAD_MORE_THRESHOLD_PX = 50;

@Component({
  selector: 'app-organize-teams-members-panel',
  templateUrl: './organize-teams-members-panel.component.html',
  styleUrls: ['./organize-teams-members-panel.component.scss']
})
export class OrganizeTeamsMembersPanelComponent {
  @Input() rows: WorkspaceMemberRow[] = [];
  @Input() allChecked = false;
  @Input() searchValue = '';
  @Input() searching = false;
  @Input() showInvite = false;
  @Input() loadingMembers = false;
  @Input() dragDisabled = false;

  @Output() searchChange = new EventEmitter<string>();
  @Output() invite = new EventEmitter<void>();
  @Output() toggleMember = new EventEmitter<string>();
  @Output() toggleAll = new EventEmitter<boolean>();
  @Output() loadMore = new EventEmitter<void>();
  @Output() dropped = new EventEmitter<OrganizeDropEvent>();

  readonly defaultAvatar = 'assets/svg/user-icon.svg';

  onToggleAll(event: Event): void {
    if (event.target instanceof HTMLInputElement) {
      this.toggleAll.emit(event.target.checked);
    }
  }

  onDropped(event: CdkDragDrop<WorkspaceMemberRow[]>): void {
    this.dropped.emit(toOrganizeDropEvent(event));
  }

  onSearchEnter(): void {
    if (this.showInvite) {
      this.invite.emit();
    }
  }

  onScroll(event: Event): void {
    const list = event.target;
    if (list instanceof HTMLElement
      && list.offsetHeight + Math.ceil(list.scrollTop) >= list.scrollHeight - LOAD_MORE_THRESHOLD_PX) {
      this.loadMore.emit();
    }
  }

  trackByUser(index: number, row: WorkspaceMemberRow): string {
    return row.member.userUuid;
  }
}
